import { NodeModel } from "../_model/NodeModel";
import { DecorationEthanolCentrifuge } from "./decorationEthanolCentrifuge";
import { Types } from "../../utils/nodeTypes";
import Properties from "../_model/ModelEngineeringProperties";

class EthanolCentrifuge extends NodeModel {
  constructor() {
    super("EthanolCentrifuge");

    this.type = new Types().EthanolCentrifuge;

    this.x = 0;
    this.y = 0;
    this.xImg = () => this.x + 2;
    this.yImg = () => this.y + 2;
    this.height = 130;
    this.width = 170;
    this.operationSelected = "";
    this.srcImg = require("@/assets/Fluxogramas/centrifuga_etanol.png");
    this.data = [new Properties({ ...this })];

    this.decorate = async function(callback) {
      this.decorator = new DecorationEthanolCentrifuge();
      await this.decorator.init(this, callback);
    };

    this.clone = () => {
      let cloned = new EthanolCentrifuge();
      cloned.id = this.id;
      cloned.idName = this.idName;
      cloned.type = this.type;
      cloned.x = this.x;
      cloned.y = this.y;
      cloned.height = this.height;
      cloned.width = this.width;
      cloned.decorator = null;
      cloned.readOnly = this.readOnly
      cloned.expressionVisible = this.expressionVisible
      cloned.data = this.data.map(d => d.clone());

      return cloned;
    };

    this.copyFrom = (node) => {
      this.simpleCopyFrom(node);
      this.data = node.data.map((d) => new Properties({ ...d }));
    };

    this.update = (node) => {
      if (node.attrs) {
        this.data = node.attrs;
      }
    };
  }
}

export { EthanolCentrifuge };
